import type { ReactNode } from "react"
import type { UseFormReturn } from "react-hook-form"

import { Form as FormShad} from "@/components/ui/form"

type FormProps = {
  form: UseFormReturn<any>
  children: ReactNode
}

export const Form = ({ form, children }: FormProps) => {
  return (
    <FormShad {...form}>
      <form className="space-y-8" onSubmit={e => e.preventDefault()}>
        {children}
      </form>
    </FormShad>
  )
}
